<template>
  <span fluid>
    <v-card class="card--flex-toolbar">
      <v-card-title class="blue-grey lighten-5">
        <h2>Cadastro de Veículos</h2>
        <v-spacer></v-spacer>
        <v-btn @click="onNewButtonClick()" small color="primary">Novo</v-btn>
      </v-card-title>
      <v-card-text>
        <e-data-table
          :headers="headers"
          :items="veiculos"
          :total="total"
          @refresh="getAll"
          @edit="editItem"
          @delete="deleteItem"
        ></e-data-table>
      </v-card-text>
      <v-card-actions></v-card-actions>
    </v-card>
  </span>
</template>
<script>
import veiculoService from '@/services/veiculos'
import EDataTable from '@/components/EDataTable'
import { showError, showConfirm, retPermissao } from '@/utils'

export default {
  name: 'plano',
  components: {
    EDataTable
  },
  data () {
    return {
      veiculos: [],
      total: 0,
      headers: [
        { text: 'Placa', value: 'placa', sortable: false },
        { text: 'Veiculo', value: 'modelo', sortable: false }],
      valid: true,
      rules: {
        nome: [v => !!v || 'Campo Requerido'],
        ativo: [v => !!v || 'Campo Requerido']
      },
      buttonSaveLoadingVisible: false
    }
  },

  methods: {
    async getAll (page, search) {
      try {
        const result = search === '' ? await veiculoService.getAll(page) : await veiculoService.getByNome(search, page)
        this.total = result._meta.total_items
        this.veiculos = result.data
      } catch (error) {
        this.planos = []
        showError(error)
      }
    },
    editItem (item) {
      var ret = retPermissao('Veículos', 'alterar')
      if (ret === true) {
        this.$router.push(`/veiculo/editar/${item.id}`)
      }
    },
    async deleteItem (item) {
      var ret = retPermissao('Veículos', 'excluir')
      if (ret === true) {
        showConfirm(`Tem certeza que deseja remover veículo ` + item.placa + ` ?`, async result => {
          if (result) {
            try {
              this.loading = true
              await veiculoService.delete(item.id)
              this.getAll(1, '')
            } catch (error) {
              showError(error)
            } finally {
              this.loading = false
            }
          }
        })
      }
    },
    onNewButtonClick () {
      var ret = retPermissao('Veículos', 'incluir')
      if (ret === true) {
        this.$router.push(`/veiculo/criar`)
      }
    }
  }
}
</script>
